<template>
  <div class="contact-page">
    <!-- Animated Car -->
    <div
      class="car-container"
      :class="{ 'car-exit': carExiting }"
      @animationend="handleAnimationEnd"
    >
      <img
        src="@/assets/images/Fiat sabz.webp"
        alt="Fiat Car"
        class="car"
      />
    </div>

    <!-- Contact Info -->
    <div class="contact-info" :class="{ 'info-enter': infoEntering }">
      <h2>Contact Us</h2>
      <p>
        <span class="icon">&#9742;</span>Phone:
         <a href="tel:+393806852464" class="contact-link">0039 3806852464</a>
      </p>
      <p>
        <span class="icon fab fa-whatsapp "  style="color: greenyellow;">WhatsApp:</span>WhatsApp:
         <a href="https://wa.me/393806852464" target="_blank" class="contact-link">0039 3806852464</a>
      </p>
      <p>
        <span class="icon fab fa-tiktok " style="color: #69c9d0;">Tiktok: </span>Tiktok:
        <a href="https://www.tiktok.com/@poorent.it?_t=8sWKYixrTRG" target="_blank" class="contact-link">Poorent.it</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage",
  data() {
    return {
      
      carExiting: false,
      infoEntering: false,
    };
  },
  methods: {
    handleAnimationEnd() {
      // When car reaches the middle, show contact info
      if (!this.carExiting) {
        // Show the contact info with a slight delay
        setTimeout(() => {
          this.infoEntering = true;
        }, 0);
     // Start the car exit animation
        this.carExiting = true;
      }
        },
  },
};
</script>

<style scoped>
/* General Styles */
.contact-page {
  position: relative;
  background-color: rgba(255, 255, 255, 0.3);
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Car Animation */
.car-container {
  position: absolute;
  top: 40%;
  right:  -200px;
  transform: translateY(-50%);
  animation: car-enter 3s linear forwards;
}

.car-container.car-exit {
  animation: car-exit 3s linear forwards;
 
}

.car {
  width: 12em;
}

/* Car Enter Animation */
@keyframes car-enter {
  0% {
    right: -200px;
  }
  50% {
    right: 50%;
    transform: translateX(-50%);
  }
  100% {
    right: 50%;
    transform: translateX(-50%);
  }
}

/* Car Exit Animation */
@keyframes car-exit {
  0% {
    left: 50%;
    transform: translateX(-50%);
  }
  100% {
    left: -200px;
  }
}

/* Contact Info */
.contact-info {
  text-align: center;
  background-color: #282c34;
  color: white;
  padding: 1rem 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  opacity: 0;
  transform: translateX(80%);
  position: absolute;
  top: 40%;
  left: 40%;
  transform: translate(-50%, -50%);
}
.contact-info.info-enter {
  animation: info-slide-in 3s linear forwards;
}

@keyframes info-slide-in {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.contact-info h2 {
  margin-bottom: 1rem;
}

.contact-info p {
  margin: 0.5rem 0;
  font-size: 1.2rem;
}

.contact-info .icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}

.contact-info .contact-link {
  color: #ff6f3c;
  text-decoration: none;
  font-weight: bold;
}

.contact-info .contact-link:hover {
  text-decoration: underline;
  color: #d62828;
}

/* Fade-in Animation for Contact Info */
@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
